const ukHostNames = [
  "uk.liquidacquire.com",
  "carson-mcdowell.liquidacquire.com",
];

const usHostNames = [""];

const awsHostNames = [
  "aws.liquidacquire.com",
  "us.liquidacquire.com",
  "itexchangenet.liquidacquire.com",
];

export function apiEndpoint() {
  let endpoint = "http://localhost:8080/graphql";

  if (import.meta.env.PROD) {
    if (ukHostNames.includes(window.location.hostname)) {
      endpoint = "https://uk.api.liquidacquire.com/graphql";
    }

    if (usHostNames.includes(window.location.hostname)) {
      endpoint = "https://us.api.liquidacquire.com/graphql";
    }

    if (awsHostNames.includes(window.location.hostname)) {
      endpoint = "https://api.rumahq.net/graphql";
    }
  }

  return endpoint;
}

export function wsEndpoint() {
  let endpoint = "ws://localhost:8080/ws";

  if (import.meta.env.PROD) {
    if (ukHostNames.includes(window.location.hostname)) {
      endpoint = "wss://uk.api.liquidacquire.com/ws";
    }

    if (usHostNames.includes(window.location.hostname)) {
      endpoint = "wss://us.api.liquidacquire.com/ws";
    }

    if (awsHostNames.includes(window.location.hostname)) {
      endpoint = "wss://api.rumahq.net/ws";
    }
  }

  return endpoint;
}

export function syncfusionSpreadsheetEndpointProxy() {
  let endpoint = "http://localhost:8080/syncfusion/api/spreadsheet/open";

  if (import.meta.env.PROD) {
    if (ukHostNames.includes(window.location.hostname)) {
      endpoint =
        "https://uk.api.liquidacquire.com/syncfusion/api/spreadsheet/open";
    }

    if (usHostNames.includes(window.location.hostname)) {
      endpoint =
        "https://us.api.liquidacquire.com/syncfusion/api/spreadsheet/open";
    }
  }

  return endpoint;
}

export function syncfusionSpreadsheetEndpoint() {
  let endpoint = "http://localhost:6002/api/spreadsheet/open";

  if (import.meta.env.PROD) {
    endpoint =
      "https://prod-us-syncfusion-spreadsheet-server.onrender.com/api/spreadsheet/open";
  }

  return endpoint;
}
